class SearchBar {
    constructor() {
        this.searchBar = document.querySelector('.search-bar');

        this.searchBarInput = document.querySelector(
            '.search-bar__input input'
        );
        this.searchBarOpen = document.querySelector('.search-bar__btn-open');
        this.searchBarClose = document.querySelector('.search-bar__btn-close');
        // this.mainNav = document.querySelector('.main-navigation');

        // this.isMobile = window.getComputedStyle(document.querySelector('.menu-hamburger')).display !== 'none';
        this.mobileSearchBar = document.querySelectorAll('.mobile-search-bar');
    }

    /**
     * Initialize the menu functionality.
     */
    init() {
        if (this.searchBarOpen) {
            this.searchBarOpen.addEventListener('click', () => {
                if (this.isMenuOpen === false) {
                    this.searchOpen();
                }
                // else {
                //     this.searchClose()
                // }
            });
        }

        if (this.searchBarClose) {
            this.searchBarClose.addEventListener('click', () => {
                if (this.isMenuOpen) {
                    this.searchClose();
                }
            });
        }

        if (Boolean(this.mobileSearchBar)) {
            /**
             * While input is in focus add .mobile-search-bar__submit should have
             * class .mobile-search-bar__submit--focus
             */

            this.mobileSearchBar.forEach((searchBar) => {
                const mobileSearchBarInput = searchBar.querySelector(
                    '.mobile-search-bar input'
                );
                const mobileSearchBarSubmit = searchBar.querySelector(
                    '.mobile-search-bar__submit'
                );

                function toggleFocusClass() {
                    return mobileSearchBarSubmit.classList.toggle(
                        'mobile-search-bar__submit--focus'
                    );
                }

                mobileSearchBarInput.addEventListener('focus', () => {
                    toggleFocusClass();
                });

                mobileSearchBarInput.addEventListener('blur', () => {
                    toggleFocusClass();
                });
            });
        }
    }

    /**
     * Open the menu.
     */
    searchOpen() {
        this.searchBar.classList.add('search-bar--active');
        this.searchBarOpen.classList.add('d-none');
        // this.mainNavVisibilityToggle();
        this.searchBarInput.focus();
    }

    /**
     * Close the menu.
     */
    searchClose() {
        this.searchBar.classList.remove('search-bar--active');
        this.searchBarOpen.classList.remove('d-none');

        // this.mainNavVisibilityToggle();
        this.clearSearchField();
    }

    /**
     * Clear search field.
     */
    clearSearchField() {
        this.searchBarInput.value = '';
    }

    /**
     * .main-navigation should be hidden when desktop search-bar is active
     */
    // mainNavVisibilityToggle() {
    //     this.mainNav.classList.toggle('d-none');
    // }

    get isMenuOpen() {
        return this.searchBar.classList.contains('search-bar--active');
    }
}

document.getElementById('searchButton').addEventListener('click', function () {
    document.getElementById('searchInput').focus();
});

export default SearchBar;